import { GetNotesFilters, INotesRepository } from '@domain/purchasing/INotesRepository';
import { Note } from '@domain/purchasing/models/Notes';
import { Resource } from '@domain/base/Resource';
import { NotesDataSource } from '../datasources/NotesDataSource';
import { NotesMapper } from '../mappers/NotesMapper';

export class NotesRepository implements INotesRepository {
  constructor(private dataSource: NotesDataSource) { }

  async getNotes(filters?: GetNotesFilters): Promise<Resource<Note[]>> {
    try {
      const notes = await this.dataSource.getNotes(filters);
      return {
        status: 'success',
        data: notes.map(NotesMapper.toModel)
      };
    } catch (error) {
      return {
        status: 'error',
        error: { type: 'UnknownError', message: 'Failed to get notes' }
      };
    }
  }

  async createNote(note: Omit<Note, 'id' | 'createdAt' | 'updatedAt'>): Promise<Resource<Note>> {
    try {
      const dto = NotesMapper.toCreateDTO(note);
      const createdNote = await this.dataSource.createNote(dto);
      return {
        status: 'success',
        data: NotesMapper.toModel(createdNote)
      };
    } catch (error) {
      return {
        status: 'error',
        error: { type: 'UnknownError', message: 'Failed to create note' }
      };
    }
  }

  async updateNote(id: string, note: Omit<Note, 'id' | 'createdAt' | 'updatedAt'>): Promise<Resource<Note>> {
    try {
      const dto = NotesMapper.toUpdateDTO(note);
      const updatedNote = await this.dataSource.updateNote(id, dto);
      return {
        status: 'success',
        data: NotesMapper.toModel(updatedNote)
      };
    } catch (error) {
      return {
        status: 'error',
        error: { type: 'UnknownError', message: 'Failed to update note' }
      };
    }
  }

  async deleteNote(id: string): Promise<Resource<void>> {
    try {
      await this.dataSource.deleteNote(id);
      return { status: 'success', data: undefined };
    } catch (error) {
      return {
        status: 'error',
        error: { type: 'UnknownError', message: 'Failed to delete note' }
      };
    }
  }
}
